export const getUrlWithoutQueryString = (url: string): string => {
  const urlWithoutQsp = new URL(url);
  urlWithoutQsp.search = '';
  urlWithoutQsp.hash = '';
  return urlWithoutQsp.toString();
};
